import * as searchPanel from './panel/searchPanel';

export default searchPanel.default;